'use client';

import Image from 'next/image';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useGetMyCardCollectionWithInitQuery } from '@/store/server/common/digital-card/digital-card.query';
import { useGetTopCollectorWithInitQuery } from '@/store/server/common/football/football.query';
import { useGetMyPointQuery } from '@/store/server/common/point/point.query';

export default function PersonalInfo() {
  const { teamSlug, packName, originalsName, topCollector } = useTeamConfig();

  // Get user points
  const { data: myPoint } = useGetMyPointQuery();
  const { data: myCardsData } = useGetMyCardCollectionWithInitQuery({ originalsName, packName });

  // Get top collector data for ranking
  const { data: topCollectorData } = useGetTopCollectorWithInitQuery({
    originalsName,
    packName,
    season: topCollector.currentSeason,
  });

  const totalCardsCount = myCardsData?.cardList?.reduce((acc, card) => acc + card.amount, 0);

  return (
    <div className="mt-2 flex w-full items-center gap-2">
      {/* Point Info */}
      <div className="flex items-center gap-1">
        <Image
          src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_point.webp`}
          alt="Point Icon"
          width={20}
          height={20}
        />
        <div className="flex items-center gap-0.5">
          <span className="typo-body-5 text-g-90">
            {myPoint?.point.toLocaleString('ko-KR') ?? '-'}
          </span>
          <span className="typo-body-5 text-g-90">P</span>
        </div>
      </div>

      <div className="h-4 w-[0.5px] bg-g-90" />


      {/* Card Info */}
      <div className="flex items-center gap-1">
        <Image
          src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_card.webp`}
          alt="Card Icon"
          width={20}
          height={20}
        />
        <div className="flex items-center gap-0.5">
          <span className="typo-body-5 text-g-90">{totalCardsCount ?? '-'}</span>
          <span className="typo-body-5 text-g-90">장</span>
        </div>
      </div>
      <div className="h-4 w-[0.5px] bg-g-90" />

      {/* Ranking Info */}
      <div className="flex items-center gap-1">
        <Image
          src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_ranking.webp`}
          alt="Rank Icon"
          width={20}
          height={20}
        />
        <div className="flex items-center gap-0.5">
          <span className="typo-body-5 text-g-90">{topCollectorData?.my?.ranking ?? '-'}</span>
          <span className="typo-body-5 text-g-90">위</span>
        </div>
      </div>


    </div>
  );
}
